import { IOrderDetailRepository } from 'orders/domain/repositories/IOrderDetailRepository'
import { OrderDetailEntity } from 'orders/domain/entities/order.entity'

export class GetOrderDetailUseCase {
    constructor(private readonly repository: IOrderDetailRepository) {}

    execute(orderId: number): Promise<OrderDetailEntity> {
        return this.repository.getOrderDetail(orderId)
    }
}
